export default __webpack_public_path__ + "static/media/Chaldean Cloak.2c81dec3.jpg";